import { useEffect } from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Preloader = ({ onDone }) => {
  useEffect(() => {
    const t = setTimeout(onDone, 2400);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <motion.div
      data-testid="intro-preloader"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-ink"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.8, ease: EASE }}
    >
      <div className="relative h-32 w-32 sm:h-40 sm:w-40">
        <motion.div
          className="absolute inset-0"
          initial={{ y: -56, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.7, ease: EASE }}
        >
          <div className="absolute left-0 top-0 h-full w-[18%] bg-gold" />
          <div className="absolute left-0 top-0 h-[16%] w-full bg-gold" />
        </motion.div>
        <motion.div
          className="absolute inset-0"
          initial={{ y: 56, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.7, ease: EASE }}
        >
          <div className="absolute left-0 bottom-0 h-[16%] w-full bg-gold" />
        </motion.div>
        <motion.div
          className="absolute left-0 top-1/2 h-[15%] w-[72%] -translate-y-1/2 origin-left bg-copper"
          initial={{ scaleX: 0, opacity: 0 }}
          animate={{ scaleX: 1, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.75, ease: EASE }}
        />
        <motion.div
          className="absolute right-[6%] top-1/2 h-[15%] w-[10%] -translate-y-1/2 rounded-full border-2 border-copper"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.4, delay: 1.0, ease: EASE }}
        />
        <motion.div
          className="absolute inset-[-14px] rounded-2xl border border-copper/50"
          initial={{ scale: 0.7, opacity: 0 }}
          animate={{ scale: 1.15, opacity: [0, 0.8, 0] }}
          transition={{ duration: 0.9, delay: 1.1, ease: "easeOut" }}
        />
      </div>

      <div className="mt-10 overflow-hidden">
        <motion.p
          className="font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-[0.35em] text-cream"
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.6, delay: 1.15, ease: EASE }}
        >
          Edilkrea
        </motion.p>
      </div>
      <div className="overflow-hidden">
        <motion.p
          className="mt-2 font-mono text-[11px] sm:text-xs uppercase tracking-[0.5em] text-gold/80"
          initial={{ y: "120%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.6, delay: 1.35, ease: EASE }}
        >
          Technoimpianti
        </motion.p>
      </div>
    </motion.div>
  );
};
